import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useUpdateSalesOrderAccountingManualMode } from '@/hooks/api/1391_update_sales_order_accounting_manual_mode';
import { useEffect, useState } from 'react';
import { toastApiError } from '@/lib/toast';
import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { Link } from 'react-router-dom';

export const ManualModeEditElement = () => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { mutate, data, isPending, error } = useUpdateSalesOrderAccountingManualMode();
  const [manualMode, setManualMode] = useState<boolean>(false);

  const onManualModeEditClick = () => {
    mutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      sales_order_id: _so_!.id,
      accounting_manual_mode: true,
    });
  };

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (_so_) setManualMode(_so_.accounting_manual_mode);
  }, [_so_]);

  useEffect(() => {
    if (data) {
      _so_!.accounting_manual_mode = data.accounting_manual_mode;
    }
  }, [data]);

  useEffect(() => toastApiError(error), [error]);

  return (
    <>
      <hr className="horizontal dark my-3" />

      <ModalConfirm
        modalId={`manualModeConfirm`}
        okClicked={() => onManualModeEditClick()}
        message={'手動管理モードに切り替えます。\nこの操作は元に戻せません。\nよろしいですか？'}
      />
      <div className="col-12 col-md-9">
        <div className="form-group">
          <label>手動管理</label>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              id="role05"
              type="checkbox"
              checked={manualMode}
              disabled={_so_!.accounting_manual_mode}
              onChange={(e) => {
                if (!_so_!.accounting_manual_mode) {
                  setManualMode((_) => !manualMode);
                }
              }}
            />
            <label className="form-check-label" htmlFor="role05">
              手動管理モードに切り替えて編集する
            </label>
          </div>
          <div className="mb-3 text-xs">
            手動管理モードをONにすると、請求実績が請求タスクから反映されなくなりますが、
            管理会計表を直接編集できます。一度手動管理モードにすると、元のモードに戻すことはできません。
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="form-group">
          <label>&nbsp;</label>
          <Link
            to={''}
            className={`btn w-100 btn-icon bg-gradient-dark ${!manualMode && 'disabled'} ${
              _so_!.accounting_manual_mode && 'disabled'
            }`}
            data-bs-toggle="modal"
            data-bs-target={`#manualModeConfirm`}
          >
            <i className="fa fa-plus"></i>切替実施
          </Link>
        </div>
      </div>
    </>
  );
};
